/**
 * Used to limit the fraction digits of a price string (format "1,0216 EUR")
 * @param value
 * @param minDigits - Minimum number of digits after the decimal point
 */
export const limitFractionDigits = (value: string, minDigits: number): string => {
    // This regex is quite specific and requires the specific format to work.
    const match = value.match(/^([\d,]+)(.*)$/);
    if (!match) return value;

    const [, numericPart, currency] = match;

    const [integer, decimal = ""] = numericPart.split(",");
    let trimmedDecimal = decimal.replace(/0+$/, "");

    // Cut off after 3 consecutive zeros
    const threeZerosMatch = trimmedDecimal.match(/^(.*?)000/);
    if (threeZerosMatch) {
        [, trimmedDecimal] = threeZerosMatch;
    }

    if (trimmedDecimal.length < minDigits) {
        trimmedDecimal = trimmedDecimal.padEnd(minDigits, "0");
    }

    return `${integer},${trimmedDecimal}${currency}`;
};
